import { call, put } from 'redux-saga/effects';
import { setLoading } from 'src/redux/commonRedux/actions';
import appHandler from '../appHandler';
import { APIHandler, APIHandlerWithSubmitting, handleError } from '../commonHandlers';

function* GetUsersHandler(api, action) {
  yield put(setLoading(true));
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetUsersSuccess, handleError);
  yield put(setLoading(false));
}

function handleGetUsersSuccess(action, response) {
  if (action.onSuccess) {
    const convertedData = {
      ...response,
      users:
        response.users?.map(user => ({
          ...user,
          name: !!user.firstName ? `${user.firstName} ${user.lastName}` : '--',
        })) || [],
    };
    action.onSuccess(convertedData);
  }
}

function* getUsers(api, action) {
  yield call(GetUsersHandler, api, action);
}

function* getUserById(api, action) {
  yield call(APIHandler, api, action);
}

function* createUser(api, action) {
  yield call(APIHandlerWithSubmitting, api, action);
}

function* updateUser(api, action) {
  yield call(APIHandlerWithSubmitting, api, action);
}

function* deleteUserById(api, action) {
  yield call(APIHandler, api, action);
}

function* getCurrentProfile(api, action) {
  yield call(APIHandler, api, action);
}

export default {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUserById,
  getCurrentProfile,
};
